import './registration.styles.scss';
import SignUpForm from '../../components/sign-up-form/sign-up-form.component';

const Registration = () => {
    return (
        <div className='registration-container'>
            <SignUpForm/>
        </div>
    )
}

export default Registration;